import { render, staticRenderFns } from "./survey_results_page.vue?vue&type=template&id=0f631cfa&scoped=true"
import script from "./survey_results_page.vue?vue&type=script&lang=js"
export * from "./survey_results_page.vue?vue&type=script&lang=js"
import style0 from "./survey_results_page.vue?vue&type=style&index=0&id=0f631cfa&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f631cfa",
  null
  
)

export default component.exports